import {
    CUSTOM_ELEMENTS_SCHEMA,
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
    PLATFORM_ID,
    Inject,
} from "@angular/core";
import {DevicesComponent} from "../devices/devices.component";
import {CommonModule, DOCUMENT, isPlatformBrowser} from "@angular/common";
import {SuccessDevicesComponent} from "../success-devices/success-devices.component";
import {PageSignalService} from "../../core/services/left-nav.service";
import {BehaviorSubject, Subscription, debounceTime, fromEvent} from "rxjs";
import {ApiHandlerService} from "../../core/services/apiCall.service";
import {Router} from "@angular/router";
import {SelectedDevicesService} from "../../core/services/device-selection.service";
import {NotificationStateService} from "../../core/services/notifications.service";
import {LoadingComponent} from "../../shared/loading/loading.component";
import {ToastrService} from "ngx-toastr";
import {AuthService} from "../../core/services/auth.service";

@Component({
    selector: "app-left-storage-nav",
    standalone: true,
    imports: [
        DevicesComponent,
        CommonModule,
        SuccessDevicesComponent,
        LoadingComponent,
    ],
    templateUrl: "./left-storage-nav.component.html",
    styleUrl: "./left-storage-nav.component.scss",
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class LeftStorageNavComponent implements OnInit {
    camerasCount = 4;
    @Input() shopCampatibleDevices: boolean = false;
    @Input() shopCampatible: boolean = false;
    @Output() planDevicesChange = new EventEmitter<boolean>();
    @Input() existingPlan: boolean = false;
    isActive: boolean = false;
    activeIndex: number = 1;
    @Input() existingPlanToNew: boolean = false;
    @Output() switchExistingToNew = new EventEmitter<boolean>();
    initialSwitch = false;
    @Input() existingPlanDevicesForMobile: boolean = false;
    leftMenuForMobile: boolean = false;
    planHaveNoDevices: boolean = true;
    hasSuccessDevicess: boolean = true;
    @Input() existingPlanToNewForMobile: boolean = false;
    @Input() checkPlanHaveNoDevices: boolean = false;
    @Input() subscriptions: any = [];
    saveButtonEnableonLeftClick: boolean = false;
    existingPlanDeviceList: any = [];
    activePlanDetails: any;
    cancelSubscription: any;
    isLoading$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
    @Input() newPlanDevicesForMobile: boolean = false;
    isMobile = false; // check mobile screen
    mobielCheck: boolean = false;
    resizeListener!: EventListenerOrEventListenerObject;
    mobileView: boolean = false;
    sussessStatus: boolean = true;
    statusForCheckSuccess: boolean = false;
    deviceLoader: boolean = false;
    notificationId: any;
    activeSuccesssIndex: number = 0;
    notifications: any = [];
    updatecheckSuccess: boolean = false;
    sanitizedCheckoutUrl: any;
    checkoutUrl: any;
    successDeviceList: any = [];
    modifyValue: boolean = false;
    activeSuccessStatus!: number;
    region: any;
    newPlanId: any;
    successPlanLIst: any = [];
    successToUpdate: boolean = false;
    @Input() devicesLIst: any = [];
    @Input() stopToClick = false;
    flowTriggered: string = "create";
    @Output() addNewPlanButtonClicked = new EventEmitter<void>();

    createCheck: boolean = false;
    deviceCheck: boolean = false;
    renewDisbalePlanId: any;
    mobileScreen: boolean = false;
    user: any;
    resizeSubscription!: Subscription;
    statusChange: boolean = false;

    // Success Device List

    planList: any = [];

    constructor(
        private cdr: ChangeDetectorRef,
        private pageSignalService: PageSignalService,
        @Inject(PLATFORM_ID) private platformId: Object,
        @Inject(DOCUMENT) private document: Document,
        // private webSocket: SocketService,
        private service: ApiHandlerService,
        private router: Router,
        private selectedDevicesService: SelectedDevicesService,
        private notificationStateService: NotificationStateService,
        private toastr: ToastrService,
        private selectionService: SelectedDevicesService,
        private authService: AuthService
    ) {
        this.resizeListener = this.checkMobileView.bind(this);
    }

    ngOnInit(): void {
        this.pageSignalService.getSignal().subscribe((signal) => {
            const PLan = signal;
            if (this.isMobile) {
                this.successDeviceList = [
                    ...PLan["subscriptionDetails"]?.association?.devices,
                ];
            }
            this.cdr.detectChanges();
        });

        if (this.devicesLIst.length) {
            this.updatecheckSuccess = true;
        }

        this.notificationStateService.planDetailsNotification$.subscribe(
            (status) => {
                if (status) {
                    this.updatecheckSuccess = false;
                }
            }
        );
        this.notificationStateService.statusForCheckSuccess$.subscribe((status) => {
            this.statusForCheckSuccess = status;
            // this.updatecheckSuccess = status;
        });
        this.notificationStateService.successDeviceList$.subscribe((devices) => {
            this.successDeviceList = devices;
        });

        this.notificationStateService.createNewPlanDevice$.subscribe((device) => {
            this.newPlanId = device;
            // this.successDeviceList = devices;
        });

        this.modifyValue = this.selectedDevicesService.getModify();

        this.selectedDevicesService.disablePlanId$.subscribe((id) => {
            this.getDisableRenewMethod(id);
        });

        if (isPlatformBrowser(this.platformId)) {
            this.checkMobileView(); // Initial check on load
            this.resizeSubscription = fromEvent(window, "resize")
                .pipe(debounceTime(200)) // Debounce for 200 milliseconds
                .subscribe(() => this.checkMobileView());
        }
        this.cancelSubscription = {};
        if (typeof window !== "undefined" && window.localStorage) {
            const user = localStorage.getItem("user");
            if (user) {
                this.getSubscriptons(user, event);
            }
        }

        this.selectedDevicesService.modify$.subscribe((value: boolean) => {
            if (value) {
                this.getModifyData();
                this.activePlan(this.activeIndex);
                this.updatecheckSuccess = true;
                this.existingPlanToNew = false;
            }
        });
        this.activePlan(1);
        // this.activeSuccessPlan(1);
        if (this.subscriptions?.length && !this.updatecheckSuccess) {
            this.planList = this.subscriptions;
        }
    }

    getSelectedPlanName() {
        return this.planList[this.activeIndex - 1]?.plan?.name;
    }

    getSubscriptionDate(subscriptionDetails: any): string {
        if (subscriptionDetails?.payment?.next?.date) {
            return subscriptionDetails.payment.next.date;
        }
        return subscriptionDetails?.next_billing_date
            ? new Date(subscriptionDetails.next_billing_date).toLocaleDateString(
                "en-US",
                {month: "short", day: "numeric", year: "numeric"}
            )
            : "";
    }

    getDisableRenewMethod(id: string) {
        if (id) {
            this.deviceLoader = true;
            const user = localStorage.getItem("user");
            const index = this.planList.findIndex(
                (device: any) => device?.subscriptionDetails?.subscription_id === id
            );
            this.service
                .Get(`subscriptions/getallusersubscriptions?user=${user}`)
                .subscribe(
                    (data: any) => {
                        this.planList = data;
                        const selectedPlan = this.planList[index];
                        this.saveButtonEnableonLeftClick = true;
                        this.activePlan(this.activeIndex);
                        this.pageSignalService.updateSignal(selectedPlan);
                        this.isLoading$.next(false);
                        this.cdr.detectChanges();
                    },

                    (error: any) => {
                        this.isLoading$.next(false);
                    }
                );
        }
    }

    //Navigate the url after checkout
    checkAndNavigate(): void {
        if (this.router.url === "/planDetails") {
            this.updatecheckSuccess = false;
            this.router.navigate(["/home"], {replaceUrl: true});
        }
    }

    ngOnDestroy() {
        if (this.resizeSubscription) {
            this.resizeSubscription.unsubscribe();
        }
    }

    checkMobileView = () => {
        if (isPlatformBrowser(this.platformId)) {
            const isCurrentlyMobile = window.innerWidth < 1200;
            if (isCurrentlyMobile !== this.isMobile) {
                this.isMobile = isCurrentlyMobile;
                this.mobielCheck = !isCurrentlyMobile;
                this.cdr.detectChanges();
            }
            // else if(isCurrentlyMobile && this.mobielCheck)
        }
    };

    // LOad the child components
    ngAfterViewInit(): void {
        setTimeout(() => {
            const selectedPlan = this.planList[0];
            if (this.statusForCheckSuccess) {
                this.pageSignalService.updateSuccessSignal(selectedPlan);
            } else {
                this.pageSignalService.updateSignal(selectedPlan);
            }
            this.mobileView = !this.mobileView;
            this.deviceLoader = false;
            this.notificationStateService.successDeviceList$.subscribe((devices) => {
                this.successDeviceList = devices;
            });
        });

        this.modifyValue = this.selectedDevicesService.getModify();
    }

    getSubscriptons(user: string, event: any) {
        this.isLoading$.next(true);
        this.service
            .Get(
                `subscriptions/getallusersubscriptions?user=${user}&date=${Date.now()}`
            )
            .subscribe(
                (data: any) => {
                    this.planList = data;
                    this.updateSubs(data, event);
                    this.isLoading$.next(false);
                    this.cdr.detectChanges();
                },
                (error: any) => {
                    this.isLoading$.next(false);
                }
            );
    }

    //upadte the subscriptons
    getCheckoutUrl(event: any) {
        this.updatecheckSuccess = false;
        const user = localStorage.getItem("user");
        if (user) {
            this.getAssets(user);
            this.getSubscriptons(user, event);
        }
    }

    updateSubs(data: any, event: any) {
        const subId = event?.subscriptionId;
        const filteredIndex = this.planList.findIndex(
            (device: any) => device?.subscriptionDetails?.subscription_id === subId
        );
        const selectedPlan = this.planList[filteredIndex];
        this.saveButtonEnableonLeftClick = true;
        if (filteredIndex >= 0) {
            this.pageSignalService.updateSignal(selectedPlan);
        }
        this.cdr.detectChanges();
    }

    updatePlanDevices(newPlanDevices: boolean) {
        this.activeIndex = -1;
        if (this.activeIndex === -1) {
            this.createCheck = true;
            this.flowTriggered = "create";
            this.updatecheckSuccess = true;
            this.mobielCheck = true;
            this.planDevicesChange.emit(false);
        } else {
            this.createCheck = false;
            this.isActive = newPlanDevices;
            this.mobielCheck = true;
            this.flowTriggered = "update";
            this.updatecheckSuccess = false;
            this.existingPlanToNew = true;
            this.planDevicesChange.emit(newPlanDevices);
        }
    }

    updateSwitch(switchStatus: boolean) {
        // this.existingPlanToNew = switchStatus;
        this.checkPlanHaveNoDevices = false;
        this.updatecheckSuccess = true;
        this.statusForCheckSuccess = false;
        this.createCheck = true;
        this.existingPlanToNew = true;
        this.deviceCheck = true;
        this.cdr.detectChanges();
        this.flowTriggered = "create";
        this.switchExistingToNew.emit(switchStatus);
        this.isLoading$.next(false);
    }

    //   get the Succes devices
    getSuccessDevice() {
        const body = {
            subscriptionIds: this.notifications,
        };
        this.planList = [];
        this.service
            .Post(`subscriptions/getusersubscriptionstatuspage`, body)
            .subscribe(
                (data: any) => {
                    this.planList = [];
                    this.planList = data;
                    this.statusForCheckSuccess = true;
                    this.updatecheckSuccess = false;
                    this.activeSuccesssIndex = 1;
                    this.planList[0]?.subscriptionDetails?.association?.devices;
                    this.notificationStateService.setStatusForCheckSuccess(true);
                    this.notificationStateService.setSuccessDeviceList(
                        this.planList[0]?.subscriptionDetails?.association?.devices
                    );
                    this.saveButtonEnableonLeftClick = true;
                    this.cdr.detectChanges();
                },
                (error: any) => {
                    // this.statusForCheckSuccess = false;
                }
            );
    }

    activePlan(index: number) {
        // if(this.cancelSubscription){
        this.deviceLoader = true;
        // this.isLoading$.next(true);
        if (index !== -1) {
            this.updatecheckSuccess = false;
            // this.createCheck = true;
        }

        this.createCheck = false;
        this.activeIndex = index;
        this.leftMenuForMobile = true;
        this.flowTriggered = "update";
        const selectedPlan = this.planList[this.activeIndex - 1];
        this.saveButtonEnableonLeftClick = true;
        this.pageSignalService.updateSignal(selectedPlan);
        this.isLoading$.next(false);
        this.deviceLoader = false;

        setTimeout(() => {
            this.deviceLoader = false;
        }, 350);
    }

    clickForMobile() {
        this.leftMenuForMobile = true;
        this.createCheck = true;
        this.isLoading$.next(false);
    }

    onMObileView() {
        this.mobielCheck = true;
        this.createCheck = true;
        this.isLoading$.next(false);
    }

    backListner(event: any) {
        const modifiedValue = event ? true : false;
        this.mobielCheck = modifiedValue;
        this.cdr.detectChanges();
    }

    getModifyData() {
        this.updatecheckSuccess = true;
        this.activePlan(this.activeIndex);
        this.saveButtonEnableonLeftClick = true;
        this.existingPlanToNew = false;
        this.createCheck = !this.createCheck;
        this.cdr.detectChanges();
    }

    getAssets(user: string) {
        this.isLoading$.next(true);
        this.service.Get(`devices/userassets?user=${user}`).subscribe(
            (data: any) => {
                if (data.code == 401) {
                    this.authService.logout();
                    this.router.navigate(["/login"]);
                }
                this.selectionService.setAssetDevices(data?.data?.devices || []);
                this.isLoading$.next(false);
            },
            (error: any) => {
                this.isLoading$.next(false);
            }
        );
    }
}
